/**
 * HeaderController
 * ヘッダーのスクロール制御 + コンテンツメニュー（SP）の開閉。
 */
export default class HeaderController {
  constructor() {
    this.header = document.getElementById('gHeader');
    if (!this.header) return;

    this.menuBtn = this.header.querySelector('.js-contentMenu-button');
    this.contentMenu = document.getElementById('contMenu');
    this.menuCloses = document.querySelectorAll('.js-contentMenu-close');

    // FV（mainVisual / keyVisual）。トップは mainVisual が sticky なので、
    // FV を覆う `.main > .container` が画面上端に達したら「FV を過ぎた」と判定する。
    this.mainVisual = document.getElementById('mainVisual');
    this.keyVisual = document.getElementById('keyVisual');
    this.cover = document.querySelector('.main > .container');
    // mv も kv も無いページはスクロール量で判定するフォールバック
    this.threshold = 200;

    this.contact = document.querySelector('.footer-contact') || document.querySelector('.contactSect');

    this.onScroll = this.onScroll.bind(this);
    window.addEventListener('scroll', this.onScroll, { passive: true });
    window.addEventListener('lenis-scroll', this.onScroll);
    window.addEventListener('resize', this.onScroll, { passive: true });
    this.onScroll();

    this.setupContentMenu();
  }

  // mv / kv の「下部」が画面上部（top: 0）に来たら true
  computePastFV() {
    if (this.mainVisual) {
      // sticky な mainVisual は rect が固定されるので、覆う container の上端で判定
      if (this.cover) return this.cover.getBoundingClientRect().top <= 0;
      return (window.scrollY || document.documentElement.scrollTop) > window.innerHeight;
    }
    if (this.keyVisual) {
      return this.keyVisual.getBoundingClientRect().bottom <= 0;
    }
    const scrollY = window.scrollY || document.documentElement.scrollTop;
    return scrollY > this.threshold;
  }

  onScroll() {
    const pastFV = this.computePastFV();
    // contact の「上部」が画面中央に来たら外す
    const contactReached = this.contact
      ? this.contact.getBoundingClientRect().top <= window.innerHeight / 2
      : false;
    // ロゴ・コンパクト表示は FV を過ぎたら維持（コンタクト接近でも消さない）
    this.header.classList.toggle('is-scrolled', pastFV);
    // 追従CV（SP 下部バー）はコンタクト接近時のみ隠す
    this.header.classList.toggle('is-contact', contactReached);
  }

  setupContentMenu() {
    if (!this.menuBtn || !this.contentMenu) return;

    const labelOpen = 'コンテンツメニューを開く';
    const labelClose = 'コンテンツメニューを閉じる';
    this.menuBtn.setAttribute('aria-label', labelOpen);

    const openMenu = () => {
      this.menuBtn.classList.add('is-active');
      this.menuBtn.setAttribute('aria-expanded', 'true');
      this.menuBtn.setAttribute('aria-label', labelClose);
      this.contentMenu.classList.add('is-visible');
      this.contentMenu.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    };

    const closeMenu = () => {
      this.menuBtn.classList.remove('is-active');
      this.menuBtn.setAttribute('aria-expanded', 'false');
      this.menuBtn.setAttribute('aria-label', labelOpen);
      this.contentMenu.classList.remove('is-visible');
      this.contentMenu.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    };

    this.menuBtn.addEventListener('click', () => {
      if (this.contentMenu.classList.contains('is-visible')) {
        closeMenu();
      } else {
        openMenu();
      }
    });

    this.menuCloses.forEach((el) => {
      el.addEventListener('click', () => closeMenu());
    });

    // メニュー内のリンクをクリックしたら閉じる
    this.contentMenu.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => closeMenu());
    });

    // Esc キーで閉じる
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && this.contentMenu.classList.contains('is-visible')) {
        closeMenu();
      }
    });

    // Tab フォーカストラップ
    const focusables = this.contentMenu.querySelectorAll('a, button, [tabindex]:not([tabindex="-1"])');
    this.contentMenu.addEventListener('keydown', (e) => {
      if (e.key !== 'Tab' || focusables.length === 0) return;
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        this.menuBtn.focus();
      }
    });
  }
}
